export const widgetPattern = /\[WIDGET [^\]]+\]/g;
export const keyWordsPattern = /\[WIDGET (<[^<>]+>) (<[^<>]+>)\]/g;
export const tagsPattern = /\[TAGS <[^<>]+>\]/g;

export const questionsPattern = /\([^()]+\)/g;
export const paramsPattern = /<[^<>]+>/g;
export const numbersPattern = /[0-9]+/g;
